import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../utils'
import { loadCity, loadCourses, loadTalents } from '../utils/Network'
import { getUsersFilterSelectStyles, makeDarkSelectStyles, withMenuPortal } from './selectStyles';

export default function SelectCourses({ callback , border , value , width, usersFilter, placeholder, menuPortal }) {

    const [SelectOptions, setSelectOptions] = useState([]);

    const baseStyles = usersFilter
        ? getUsersFilterSelectStyles({ width: width || '220px', border })
        : makeDarkSelectStyles({ width: width || '220px', border });
    const customStyles = menuPortal && !usersFilter ? withMenuPortal(baseStyles) : baseStyles;

    
    useEffect(() => {
        loadCourses().then(courses => {
            if (courses) {
                var temp = []
                var temp_options = []

                temp_options.push({
                    label : "No Contest",
                    value : 0
                })
                courses.map((item, i) => {
                    temp.push(item)
                    var option = null;
                        option = {
                            label: getDefaultName(item.names),
                            value: item.id
                        }
                    temp_options.push(option)
                })
                setSelectOptions(temp_options);
            }
        })
    }, [])

    const handleSelect = (e) => {
        callback(e && e.value,"course")

    }

    return (
        <>
            <div className="filter-select">
                <Select
                    options={SelectOptions}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder || "Course"}
                    isClearable = {true}
                    isSearchable={false}
                    value={SelectOptions && (SelectOptions.find(obj => obj.value == value) || null)}
                    menuPortalTarget={(menuPortal || usersFilter) && typeof document !== 'undefined' ? document.body : undefined}
                    menuPosition={(menuPortal || usersFilter) ? 'fixed' : undefined}
                />
            </div>
            
        </>
    )
}
